import { ProductStock } from "@TmpApp/types";
import clsx from "clsx";
import * as React from "react";
import { InventoryStatusProps } from ".";

export const getInventoryStatusClass = (
    stock: ProductStock,
    highQty: number = 3,
    lowQty: number = 1
): string => {
    if (stock.qty <= 0) {
        return "tmp-inventory-status-quantity-none";
    }

    if (stock.qty <= lowQty) {
        return "tmp-inventory-status-quantity-low";
    } else if (stock.qty > lowQty && stock.qty < highQty) {
        return "tmp-inventory-status-quantity-medium";
    }

    return "tmp-inventory-status-quantity-high";
};

const InventoryStatus: React.FC<InventoryStatusProps> = ({
    atDealerText = "På lager hos forhandler, kontakt os for levering",
    textOnly = false,
    ...props
}) => {
    const renderAtDealer = () => {
        return <div className="tmp-inventory-status-shipping-time">{atDealerText}</div>;
    };

    const renderDeliveryText = () => {
        return (
            <div className="tmp-inventory-status-shipping-time">{props.product.delivery_text}</div>
        );
    };

    const renderInventory = () => {
        let hover_title = " på lager";
        if (props?.settings?.inventory_hover_title) {
            hover_title = props?.settings?.inventory_hover_title;
        }
        const inventory_amount = props.product.stock.more_qty ? "3+" : props.product.stock.qty;
        hover_title = inventory_amount + hover_title;
        return (
            <React.Fragment>
                {props?.settings?.show_inventory_title === "yes" ? renderInventoryTitle() : ""}
                {textOnly ? null : (
                    <ul
                        className={clsx(
                            "tmp-inventory-status",
                            getInventoryStatusClass(props.product.stock)
                        )}
                        title={hover_title}
                    >
                        <li className="tmp-inventory-status-item"></li>
                        <li className="tmp-inventory-status-item"></li>
                        <li className="tmp-inventory-status-item"></li>
                    </ul>
                )}
                <span className="tmp-inventory-status-text">{hover_title}</span>
            </React.Fragment>
        );
    };

    const renderInventoryTitle = () => {
        return <div className="tmp-inventory-status-title">{props.settings.inventory_title}</div>;
    };

    return (
        <div className="tmp-inventory-status-container">
            {props.product.stock.located_at_dealer
                ? renderAtDealer()
                : props?.product?.stock.qty <= 0 && props.product.delivery_text
                ? renderDeliveryText()
                : renderInventory()}
        </div>
    );
};

export default InventoryStatus;
